import { UiModel } from "@durlabh/dframework-ui";
import documentConfig from "./childGrids/Document";
import { useParams } from "react-router";

const hookupDocumentConfig = {
  ...documentConfig,
  columns: [...documentConfig.columns]
};
delete hookupDocumentConfig.joinColumn;

const DocumentModel = new UiModel({
  ...hookupDocumentConfig,
  permissions: { add: true, edit: false, delete: false },
  nestedGrid: true,
  selectionApi: "HookupDocs",
  api: "AddHookupDocument",
  idProperty: "DocumentID",
  enableGoBack: true,
  selectionUpdateKeys: ["DocumentID", "EquipmentScopeId"],
  customAddText: "Add",
  columns: [
    {
      label: '',
      field: 'selection Box',
      type: 'selection',
      width: 100,
      sortable: false,
      filterable: false,
      exportable: false
    },
    ...hookupDocumentConfig.columns
  ]
});

const AddHookupDocumentGrid = ({ equipmentGroupId }) => {
  const { equipmentId, equipmentScopeId } = useParams();
  return (
    <DocumentModel.Grid baseFilters = {[
      {
        field: "AssociationId",
        operator: "equals",
        value: equipmentId,
        type: "number"
      },
      {
        field: "DocumentGroupId",
        operator: "equals",
        value: equipmentGroupId,
        type: "number"
      },
      {
        field: "EquipmentScopeIds",
        operator: "notContains",
        value: equipmentScopeId,
        type: "csv"
      }
    ]}
    onCellDoubleClickOverride={() => {}}
    />
  );
};
export default AddHookupDocumentGrid;